import React from 'react';
import PropTypes from 'prop-types';
import SMORoomEditBaseFragment from './SMORoomEditBaseFragment';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMConst from 'lib/SMConst';
import SMORoomEditOptionView from './SMORoomEditOptionView';
import update from 'react-addons-update';
import SMRoomHelper from 'components/helpers/SMRoomHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMORoomEditOptionFragment extends SMORoomEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      room: this.props.room,
      items: this.props.items,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  getInitialState(){
    return {
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
    const self = this;
    let originalPosition,
        $sortable = $(this.refs.sortable);
    $sortable.sortable({
      start(e, ui) {
        originalPosition = ui.item.index();
      },
      update(e, ui) {
        let items = update(self.props.items, {$splice: [ 
          [originalPosition, 1], 
          [ui.item.index(), 0, self.props.items[originalPosition]] 
        ]});
        items.forEach(function(item, index) {
          item.sort_order = index;
        });
        self.sortOrderDidChange(e, {name: self.props.name, items: items});
      }
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      items : nextProps.items,
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  actionButtonDidClick(status,label,e) {
    this.trackPageEvent(label);
    if(this.props.delegate && typeof this.props.delegate.actionButtonDidClick === 'function') {
      this.props.delegate.actionButtonDidClick(status, e);
    }
  }
  
  handleAddItem(e) {
    e.preventDefault();
    this.setState(function(previousState, currentProps) {
      let newItem = {
        countable: false,
        max_count: null,
        name: "",
        description: "",
        has_session_price: 1,
        session_price: null,
        session_price_unit: null,
        sort_order: previousState.items.length,
      };
      previousState.items.push(newItem);
      
      return {
        items: previousState.items,
      };
    });
  }
  
  handleDeleteItem(item, index, e) {
    if (item.id) {
      $(document).trigger("SMRoomHandleDestroyHasManyAssociationItems", [{name: this.props.name, id: item.id}]);
    } else {
      this.setState(function(previousState, currentProps) {
        delete previousState.items[index];
        return {
          items: previousState.items,
        };
      });
    }
  }

  renderActionButtons() {
    let actionButton;
    if (this.props.name == 'option_items') {
      actionButton = <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>;
    } else {
      if (!this.props.room.can_display || !this.props.space.can_display) {
        actionButton = <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className='button button-gray maincol-buttonarea__button' onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible,'od temporarily_save room_1')}>終了</a>;
      } else if (this.props.owner.status == SMConst.OwnerStatus.Created) {
        actionButton = <a href={Routes.owner_dashboard_settings_review_path(this.props.owner.username)} className='button button-green maincol-buttonarea__button' onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible,'od owner_review')}>掲載審査へ</a>;
      } else {
        actionButton = <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className='button button-green maincol-buttonarea__button' onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible,'od save visible_room_1')}>公開して終了</a>;
      }
    }
    
    return <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">{actionButton}</div>;
  }

  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>{I18n.t("dashboard."+this.props.name+".text_000001")}
          <span className="dashboard-title__supplement ml15">
            {I18n.t("dashboard."+this.props.name+".text_000002")}
          </span>
        </h2>

        <div>
          <div ref="sortable">
            {this.props.items.map((item, index)=>{
              return (
                <SMORoomEditOptionView
                  name={this.props.name} 
                  key={item.id+'-'+index} 
                  delegate={this} 
                  item={item} 
                  index={index} 
                  isRequiredOption={this.props.name == 'option_foods' && this.props.items.length == 1 && SMRoomHelper.isRequireOptionFood(this.props.room) ? true : false} 
                  errors={this.props.errors} />
              );
            })}
          </div>
          <div className="form-box">
            <a href='#' className="button button-gray form-img-button" onClick={this.handleAddItem.bind(this)}><i className="fa fa-plus"></i>{I18n.t("dashboard."+this.props.name+".text_000003")} </a>
          </div>
          <SMOAcademyLinkBaloonView 
            displayPlace={(this.props.name == "option_items") ? SMConst.AcademyLinkDisplayPlace.RoomOption : SMConst.AcademyLinkDisplayPlace.RoomFood} 
            isCurrent={this.state.isCurrent} />
        </div>

        {this.renderActionButtons()}
      </div>
    );
  }
}
SMORoomEditOptionFragment.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  space: PropTypes.object.isRequired,
};
SMORoomEditOptionFragment.defaultProps = {
  errors: [],
};
export default SMORoomEditOptionFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditOptionFragment.jsx